import { render, staticRenderFns } from "./goods-manage.vue?vue&type=template&id=0bf3ea08&"
import script from "./goods-manage.vue?vue&type=script&lang=js&"
export * from "./goods-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports